<script>
  import { styles } from "./styles.js";
  let link = "https://bit.ly/passion-reader-2020-drop";
</script>

<style>
</style>

  <div class="space-y-2 space-x-1 lg:flex">
    <a class="flex w-[175px] text-slate-400 text-sm font-bold border-2 border-slate-400 rounded mt-6 p-2 {$styles.hoverbutton}" href={link}>
      <img src="assets/icon-download.svg" alt="icon">
      <p class="pl-2"> Download Full PDF </p>
    </a>
    <div class="text-center lg:text-left lg:pl-2 text-slate-500 text-sm lg:grid lg:content-center lg:pt-4">2020 / 100mb
    </div>
    
 </div>
